export const messageSendAttachment = {
  name: "Mensagem de envio de Anexo",
  gender: "female",
  content: `
  %0AOlá *{{tutorName}}* 🐶,
  %0A%0A*{{veterinaryName}}* da *{{storeName}}* enviou um arquivo importante sobre a última consulta {{petArticle}} *{{petName}}*, em *{{{date}}}*. Você pode dar uma olhada no arquivo acessando o link abaixo:
  %0A%0A{{{attachmentPath}}}
  %0A%0ASe precisar de alguma assistência ou tiver dúvidas, estamos à disposição.
  %0A%0AAtenciosamente,
  %0A*{{veterinaryName}}*
  %0A_{{storeName}}_ 🩺 🐾
  `.trim(),
};
